/**
 * Part del l'API del AdrWidget
 * Component: AdrWidgetAPI.ts
 * Llenguatge: TypeScript
 * Autors: Xavier Naval
 * Versió: 1.0
 * Data: 29/09/2017
 * (c) Ajuntament de Manresa - set 2017 - Departament de Sistemes d'Informació
 */
import AjtAjaxAxios from 'ajt-ajax';
import { INumero } from '../interfaces/IAdr';

export default class AdrWidgetAPI {
    // Constructor
    constructor(urlAPI?: string) {
        if (urlAPI) {
            this.urlBase = urlAPI;
        }
    }

    // Request
    private req: AjtAjaxAxios = new AjtAjaxAxios();

    // Base de dades per defecte
    bd: string = 'AJT';

    // URL base on hi ha l'api per els RefCadWidget
    urlBase: string = 'http://intranetserver/intranet/public/NucliPublic/1.0/api';
    // urlBase: string = 'http://localhost:64366/api';

    // URL completa on hi ha l'api per els RefCadWidget
    get url(): string {
        return `${this.urlBase}/${this.bd}/`;
    }

    // Dona accés el Request d'aquesta api
    get request(): AjtAjaxAxios {
        return this.req;
    }

    // Retorna un Promise amb un array amb els números que l'adreça' coincideix amb el paràmetre pAdreca
    // pAdreca: Part del nom de carrer a buscar (no s'ha de posar ni el tipus de via, ni l'article. El número sí que es pot posar)
    // pSkip: número de registres a saltar
    // pPageSize: Número de registres a retornar
    getNumeroPerAdreca(pAdreca: string, pSkip: number, pPageSize: number): Promise<Array<INumero>> {
        return this.req.getSequentialRequest(this.url + 'NCL_NUMERO/MPerAdreca', { id: pAdreca, skip: pSkip, pageSize: pPageSize }) as Promise<Array<INumero>>;
    }

    // Retorna un Promise amb el número del NumCod demanat
    // pNumCod: NumCod a buscar
    getNumeroPerNumCod(pNumCod: number): Promise<INumero> {
        return this.req.getSequentialRequest(this.url + 'NCL_NUMERO/M2PerNumCod', { id: pNumCod }) as Promise<INumero>;
    }

}